
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import Input from '@/components/Core/Input.vue';

  import { IErrorModel } from '@/models/errors.model';
  import { IOAuthModel } from '@/models/oauth.model';
  import { IVerifyTokenResult } from '@/models/token.model';

  import tokenService from '@/services/token.service';
  import errorsService from '@/services/errors.service';
  import accountService from '@/services/account.service';

  @Component({
    components: {
      Input
    },
    computed: {
      ...mapGetters([
        'token',
        'isLoading',
        'clientId'
      ])
    }
  })
  export default class OAuth extends Vue {
    created() {
      this.$store.dispatch("updateIsLoading", true);
      this.$data.errors = new Array<IErrorModel>();
      this.$data.hasErrors = false;

      var token = tokenService.hasToken(this);

      if (token == null) {
        this.getOAuth("Anonymous");

        return;
      }

      const verifyUrl: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "token/verify";

      accountService.get<IVerifyTokenResult>(this, verifyUrl, { params: { client_id: this.$data.RCEnvironment.VUE_APP_API_KEY, access_token: token }, headers: { Authorization: "Bearer Anonymous", "Cache-Control": "no-cache" } })
        .then(result => {
          result.ExpiresIn < 0 ? this.getOAuth("Anonymous") : this.getOAuth(token);
        }).catch(() => {
          this.$cookies.remove("_g2g_identity_");
          this.getOAuth("Anonymous");
        });
    }

    getOAuth(token: string) {
      const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "oauth";

      if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == "FOCUS" || this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == "CREATIVE-ASSEMBLY") {
        const loginRedirect = localStorage.getItem("login_redirect_uri");

        if (loginRedirect != null) {
          this.$route.query.redirect_uri = loginRedirect;
          localStorage.removeItem("login_redirect_uri");
        } else {
          const redirectUri = this.$route.query.redirect_uri;
          if (redirectUri != null && redirectUri != undefined && redirectUri != '') {
            localStorage.setItem("login_redirect_uri", redirectUri.toString());
          }
        }

        const loginState = localStorage.getItem("login_state");

        if (loginState != null) {
          this.$route.query.state = loginState;
          localStorage.removeItem("login_state");
        } else {
          const state = this.$route.query.state;
          if (state != null && state != undefined && state != '') {
            localStorage.setItem("login_state", state.toString());
          }
        }
      }

      accountService.get<IOAuthModel>(this, url, { params: this.$route.query, headers: { Authorization: "Bearer " + token } })
        .then(result => {
          if (result.RedirectUri != null) {
            const redirectUri = result.RedirectUri;

            const redirectUrl = new URL(redirectUri).searchParams.get("redirectUrl");

            if (redirectUrl != null) {
              localStorage.setItem("oauth_redirect_url", redirectUrl.toString());
            }

            if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == "FOCUS") {
              let urlParams = new URLSearchParams(window.location.search);

              const utmQueryParams: Array<string> = new Array<string>();
              urlParams.forEach((value: string, key: string) => {
                if (key.startsWith("utm")) {
                  utmQueryParams.push([key, value].join("="));
                }
              });

              if (utmQueryParams.length) {
                localStorage.setItem("utm_query_params", utmQueryParams.join(","));
              } else {
                localStorage.removeItem("utm_query_params");
              }
            }

            window.location.href = redirectUri;
          } else {
            this.$store.dispatch("updateIsLoading", false);
          }
        })
        .catch(error => {
          this.$store.dispatch("updateIsLoading", false);

          errorsService.handleErrors(this, error);
        });
    }
  }
